export default {
  SAVE_GROUP: 'saveGroup',
  GET_ALL_GROUPS: 'getAllGroups',
  GET_ALL_GROUPS_BY_USER_TENANT: 'getAllGroupsByUserTenant',
  DELETE_GROUP: 'deleteGroup',
  HANDLE_APPLICATIONS_ITEMS: 'handleApplicationsItems',
  GET_GROUPS_BY_COMPANY: 'getGroupsByCompany',
  GET_USER_GROUP: 'getUserGroup',
  GET_USERS_FROM_GROUP: 'getUsersFromGroup',
  UPDATE_USER_GROUP_MANAGER: 'updateUserGroupManager',
  DELETE_USER_FROM_GROUP: 'deleteUserFromGroup'
}
